<div class="edited-jobs-history-wrapper">
    <div class="header-dialog">
        <h1>Jobs History</h1>
        <button mat-icon-button class="closer" [mat-dialog-close]="">
            <mat-icon mat-list-icon>close</mat-icon>
        </button>
    </div>

    <div class="headers">
        <div>ID</div>
        <div>PM#</div>
        <div>Notification #</div>
        <div>Street Address</div>
        <div>City</div>
        <div>Status</div>
    </div>
    <div class="job-rows-container">
        <div class="job-row-wrapper">
            <div class="job-row" *ngFor="let job of jobsHistoryData" (click)="jobSelected(job)">
                <div>{{job.jobID}}</div>
                <div>{{job.jobNumber}}</div>
                <div>{{job.notificationNumber}}</div>
                <div>{{job.address1}}</div>
                <div>{{job.city}}</div>
                <div>{{job.status}}</div>
            </div>
        </div>
    </div>
</div>